module.exports = __webpack_public_path__ + "img/inter_throw_rotate.24237b4a.svg";